import React from 'react';
import styles from './wrapper.module.css';

export const PageContentWrapper = ({ className, children }) => {
  return <div className={`${styles.pageContent} ${className || ''}`}>{children}</div>;
};
